import { useMemo } from 'react';

import ManageSearch from '@mui/icons-material/ManageSearch';
import { Link as RouterLink } from 'react-router';

import Crown from '@/assets/icons/Crown';
import Button from '@/components/Buttons/Button';
import { useAppDispatch } from '@/hooks/redux-hooks';
import useUserDetails from '@/hooks/useUserDetails';
import { closeDrawer } from '@/slices/drawerSlice';

import type { SxProps } from '@mui/material';

const UpgradeToPremiumButton = ({
  sx,
  type
}: {
  sx?: SxProps;
  type: 'expired' | 'manage' | 'upgrade';
}) => {
  const { isUserExpired } = useUserDetails();
  const dispatch = useAppDispatch();
  const content = useMemo(() => {
    if (isUserExpired) {
      return {
        icon: Crown,
        label: 'Upgrade now'
      };
    }
    switch (type) {
      case 'expired':
        return {
          icon: Crown,
          label: 'Upgrade now'
        };
      case 'manage':
        return {
          icon: ManageSearch,
          label: 'Manage subscription'
        };

      default:
        return {
          icon: Crown,
          label: 'Upgrade to Premium'
        };
    }
  }, [isUserExpired, type]);
  return (
    <Button
      component={RouterLink}
      sx={{ width: 250, outline: 'none', boxShadow: 'none', border: 'none', ...sx }}
      to='/manage-subscription'
      variant='contained'
      onClick={() => {
        dispatch(closeDrawer());
      }}
    >
      <content.icon />
      {content.label}
    </Button>
  );
};

export default UpgradeToPremiumButton;
